<template>
  <div>
    <v-main>
      <div style=" overflow-x: hidden">
        <v-row style="padding:1% 2%; height: 100px;">
          <v-col xs="10" sm="10" md="10" lg="10">
            <h2>เพิ่มเหรียญ</h2>
          </v-col>
        </v-row>
        <v-divider style="padding-top:0; margin: 0px 0px"></v-divider>
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row style="padding-top: 20px;">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <h3>
                      1. กรอกข้อมูล ( <span style="color: red;">*</span> จำเป็น
                      ) และกดปุ่มตรวจสอบ
                    </h3>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-select
                      v-model="formAdd.productExchangeRateId"
                      label="สินค้า/บริการ"
                      outlined
                      :items="ProductExchangeRate"
                      :rules="[rules.required]"
                      :menu-props="{ bottom: true, offsetY: true }"
                      required
                    ></v-select>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.amount"
                      label="จำนวนเงิน (บาท)"
                      type="number"
                      :min="0"
                      outlined
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.tel"
                      label="เบอร์โทรศัพท์"
                      v-mask="'###-###-####'"
                      outlined
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-select
                      v-model="formAdd.masBranchID"
                      label="สาขา"
                      outlined
                      :items="dataBranch"
                      :rules="[rules.required]"
                      :menu-props="{ bottom: true, offsetY: true }"
                      required
                    ></v-select>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.refId"
                      label="เลขอ้างอิง"
                      outlined
                      @input="formAdd.refId = normalizeRefId(formAdd.refId)"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="padding-colH"
                    style="padding-bottom: 8%"
                  >
                    <v-btn
                      block
                      large
                      color="primary"
                      v-if="confirmBtn === true"
                      @click="validate(), addData()"
                      >ตรวจสอบ
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <h3>
                      2.ตรวจสอบข้อมูลลูกค้า และกดปุ่ม
                      <span style="color: #25D252;">เพิ่มเหรียญ</span>
                    </h3>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-card max-width="460">
                      <v-row v-if="formProfile.memberId === ''">
                        <v-col class="text-center">
                          <h2>ตรวจสอบข้อมูลลูกค้า</h2>
                        </v-col>
                      </v-row>
                      <v-col class="text-center">
                        <v-avatar color="primary" size="150">
                          <img
                            :src="
                              formProfile.picture !== ''
                                ? formProfile.picture
                                : 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
                            "
                            alt="John"
                          />
                        </v-avatar>
                        <v-card-title class="text-h5">
                          <v-col class="text-center">
                            {{
                              formProfile.name
                                ? formProfile.name
                                : 'สมชาย สีสะอาด'
                            }}
                          </v-col>
                        </v-card-title>
                      </v-col>

                      <v-row>
                        <v-col class="text-center"
                          >เหรียญคงเหลือ :
                          {{
                            formProfile.point
                              ? formatNumber(formProfile.point)
                              : '-'
                          }}</v-col
                        >
                      </v-row>
                      <v-divider
                        style="padding-top:0; magin: 0px 0px"
                      ></v-divider>
                      <v-container>
                        <v-row>
                          <v-col class="text-start" style="color:#4a4a4a"
                            >ชื่อ-สกุล</v-col
                          >
                          <v-col class="text-end">{{
                            formProfile.nameCustomer
                              ? formProfile.nameCustomer
                              : '-'
                          }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col class="text-start" style="color:#4a4a4a"
                            >เบอร์โทรศัพท์</v-col
                          >
                          <v-col class="text-end" v-mask="'###-###-####'">{{
                            formProfile.tel ? formProfile.tel : '-'
                          }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col class="text-start" style="color:#4a4a4a"
                            >ระดับ</v-col
                          >
                          <v-col class="text-end">{{
                            formProfile.LevelName ? formProfile.LevelName : '-'
                          }}</v-col>
                        </v-row>
                      </v-container>

                      <v-card-text v-if="blockAddCoin">
                        <v-alert
                          type="warning"
                          dense
                          text
                          border="left"
                          class="mb-0"
                        >
                          บัญชีนี้ยังไม่ได้อัปเดตข้อมูลกรุณาให้ลูกค้าอัปเดตข้อมูลให้เรียบร้อย
                          จากนั้นกดตรวจสอบอีกครั้งจึงจะแจกเหรียญได้
                        </v-alert>
                      </v-card-text>
                      <v-card-text v-else>
                        <v-row>
                          <v-col></v-col>
                          <v-col></v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="#f74569"
                          dark
                          @click="
                            ;(dialog = false), (confirmBtn = true)
                            reset(),
                              clear(),
                              getProductExchangeRate(),
                              getDataBranch()
                          "
                          v-if="formProfile.memberId !== ''"
                        >
                          ยกเลิก
                        </v-btn>
                        <v-btn
                          color="#25D252"
                          dark
                          :loading="loading"
                          @click="confirm(), confirm === true"
                          v-if="formProfile.memberId !== '' && !blockAddCoin"
                        >
                          เพิ่มเหรียญ
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <v-dialog v-model="dialogReCheck" persistent max-width="490">
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
export default {
  data () {
    return {
      session: this.$session.getAll(),
      path: '/qrcode/', // Path Model
      returnLink: '/Tool/CollectQRCode',
      valid: true,
      dialogReCheck: false,
      profile: false,
      loading: false,
      loadingStatus: false,
      formAdd: {
        productExchangeRateId: '',
        amount: '',
        tel: '',
        masBranchID: '',
        refId: '',
        point: '',
        token: '',
        status: 'waiting',
        statusMemberCard: 'collect',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        CREATE_DATE: ''
      },
      formProfile: {
        picture: '',
        name: '',
        tel: '',
        point: '',
        totalpoint: '',
        LevelName: '',
        nameCustomer: '',
        memberId: '',
        lineUserIdNewProvider: ''
      },
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      ProductExchangeRate: [],
      dataBranch: [],
      confirmBtn: true,
      cancelBtn: false,
      providerCheckAllShops: false,
      providerCheckShopIds: [
        'SHOP_20260218130804572123',
        'Uc520945108b983b6e739ed0a8cd8dae4'
      ]
    }
  },
  computed: {
    providerCheckEnabled () {
      return (
        this.providerCheckAllShops ||
        this.providerCheckShopIds.indexOf((this.session.data || {}).shopId) !==
          -1
      )
    },
    memberNotMigrated () {
      return (
        this.formProfile.memberId !== '' &&
        !String(this.formProfile.lineUserIdNewProvider || '').trim()
      )
    },
    blockAddCoin () {
      return this.providerCheckEnabled && this.memberNotMigrated
    }
  },
  beforeDestroy () {
    this.ProductExchangeRate = null
    this.dataBranch = null
  },
  mounted () {
    this.getProductExchangeRate()
    this.getDataBranch()
  },
  methods: {
    async getProductExchangeRate () {
      this.ProductExchangeRate = []
      await axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            s.userId = d.userId
            d = s
            console.log(d)
            this.ProductExchangeRate.push(d)
          }
          console.log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async getDataBranch () {
      this.dataBranch = []
      await axios
        .get(
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = s.value
            this.formAdd.branchName = s.text
          }
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    addData () {
      console.log(this.$refs.form.validate())
      if (this.$refs.form.validate() === true) {
        axios
          .get(
            this.DNS_IP +
              '/member/get?shopId=' +
              this.session.data.shopId +
              '&tel=' +
              this.formAdd.tel
                .split('-')
                .join('')
                .trim()
          )
          .then(result => {
            if (result.data.status === false) {
              this.$swal(
                'ไม่พบบัญชีผู้ใช้',
                'กรุณาตรวจสอบหมายเลขโทรศัพท์',
                'error'
              )
              this.clear()
              this.reset()
            } else {
              this.profile = true
              if (result.data[0].pictures !== '') {
                this.formProfile.picture = result.data[0].picture
              } else {
                this.formProfile.picture =
                  'https://cdn.vuetifyjs.com/images/cards/cooking.png'
              }
              this.formProfile.picture = result.data[0].picture
              this.formProfile.name = result.data[0].name
              this.formProfile.tel = result.data[0].tel
              this.formProfile.point = result.data[0].currentPoint
              this.formProfile.totalPoint = result.data[0].collectPoint
              this.formProfile.LevelName = result.data[0].LevelName
              this.formProfile.nameCustomer = result.data[0].nameCustomer
              this.formProfile.memberId = result.data[0].memberId
              this.formProfile.lineUserIdNewProvider =
                result.data[0].lineUserIdNewProvider || ''
              console.log(result.data)
            }
          })
      }
    },
    normalizeRefId (val) {
      return (val || '').toString().replace(/\s+/g, '')
    },
    async isDuplicateRefId (refId) {
      try {
        const res = await axios.get(
          this.DNS_IP +
            '/qrcode_by_refId?shopId=' +
            this.$session.getAll().data.shopId +
            '&refId=' +
            encodeURIComponent(refId)
        )
        return Array.isArray(res.data) && res.data.length > 0
      } catch (e) {
        return false
      }
    },
    async confirm () {
      this.loading = true
      this.formAdd.refId = this.normalizeRefId(this.formAdd.refId)
      if (
        this.formAdd.refId &&
        (await this.isDuplicateRefId(this.formAdd.refId))
      ) {
        this.$swal(
          'เลขอ้างอิงนี้แจกเหรียญไปแล้ว',
          'กรุณาตรวจสอบเลขอ้างอิงอีกครั้ง หากลูกค้าแจ้งว่าไม่ได้รับเหรียญ ให้ลูกค้ารีเฟรชหน้าสะสมเหรียญก่อน',
          'error'
        )
        this.loadingStatus = false
        this.loading = false
        return
      }
      var data = {
        refId: this.formAdd.refId,
        shopId: this.$session.getAll().data.shopId,
        tel: this.formAdd.tel
          .split('-')
          .join('')
          .trim(),
        Amount: this.formAdd.amount,
        exchangRateId: this.formAdd.productExchangeRateId.toString(),
        masBranchID: this.formAdd.masBranchID,
        branchName: this.formAdd.branchName,
        User: this.$session.getAll().data.displayName,
        source: false
      }
      axios.post(this.DNS_IP + '/POSapi', data).then(response => {
        console.log('POSapi"', response)

        if (response.data && response.data.status === false) {
          this.$swal('ไม่สามารถแจกเหรียญได้', response.data.message, 'error')
          this.loadingStatus = false
          this.loading = false
          return
        }
        this.$swal('เรียบร้อย', 'เพิ่มเหรียญเรียบร้อย', 'success')
        this.loadingStatus = false
        this.loading = false
        this.clear()
        this.reset()
        this.getProductExchangeRate()
        this.getDataBranch()
        this.loading = false
      })
    },
    clear () {
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = ''
      this.formAdd.tel = ''
      this.formAdd.masBranchID = ''
      this.formAdd.refId = ''
      this.formAdd.point = ''
      this.formAdd.token = ''
      this.formAdd.status = 'waiting'
      this.formAdd.statusMemberCard = 'collect'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.session.data.shopId
      this.formAdd.qrCodeURL = ''
      this.formAdd.CREATE_DATE = ''
      this.formProfile.picture = ''
      this.formProfile.name = ''
      this.formProfile.tel = ''
      this.formProfile.point = ''
      this.formProfile.totalPoint = ''
      this.formProfile.LevelName = ''
      this.formProfile.nameCustomer = ''
      this.formProfile.memberId = ''
      this.formProfile.lineUserIdNewProvider = ''
    }
  }
}
</script>
<style scope>
.padding-colH {
  padding: 5px 15px 0px;
}
.v-text-field {
  padding: 0px 16px 0px !important;
}
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/AddCoin.vue